import './refineTimeframe.html';
import stateGo from 'redux-ui-router/lib/state-go';

export default function() {
  return {
    replace: true,
    scope: {
      timeframes: '=',
    },
    templateUrl: 'directives/refineTimeframe/refineTimeframe.html',
    controller: Controller,
    controllerAs: 'vm',
    bindToController: true,
  };
}

Controller.$inject = ['$scope', '$ngRedux'];
function Controller($scope, $ngRedux) {
  const disconnect = $ngRedux.connect((state) => {
    return {
      router: state.router,
    };
  })(this);

  $scope.$on('$destroy', disconnect);

  // Initialize timeframe state
  const timeframeLength = this.timeframes ?
    this.timeframes.length - 1 :
    1;

  // Update url when timeframe selection changes
  ['currentTimeframe', 'startTimeframe'].forEach((select) => {
    $scope.$watch(
      () => this[select],
      (newval, oldval) => {
        const noStartTimeframe = !this.router.currentParams.activeTab ||
          this.router.currentParams.activeTab !== 'graph';

        // We want to return if there is no value change
        // and if current and start timeframes are already set.
        if (newval === oldval &&
          this.router.currentParams.currentTimeframe &&
          (!noStartTimeframe && this.router.currentParams.startTimeframe)) {
          return;
        }
        let newTimeframe = {
          [select]: newval,
        };
        if (noStartTimeframe) {
          newTimeframe = angular.extend({}, newTimeframe, {
            startTimeframe: undefined,
          });
        }
        $ngRedux.dispatch(stateGo('datacenter.main', newTimeframe));
      }
    );
  });

  // Onload update...
  $scope.$watch(
    () => this.timeframes,
    (newval) => {
      if (newval !== 'undefined') {
        ['currentTimeframe', 'startTimeframe'].forEach((select) => {
          if (this.router.currentParams[select]) {
            this[select] = this.router.currentParams[select];
          }
        });
      }
    }
  );

  this.currentTimeframe = this.router.currentParams.currentTimeframe || '0';
  this.startTimeframe = this.router.currentParams.startTimeframe ||
    timeframeLength.toString();

  // When switching to graph view, ensure that selections are ordered correctly
  $scope.$watch(
    () => this.router.currentParams.activeTab,
    (newval, oldval) => {
      if (newval === 'graph' && newval !== oldval) {
        this.startTimeframe = `${this.timeframes.length - 1}`;
        if (parseInt(this.startTimeframe, 10) ===
          parseInt(this.currentTimeframe, 10)
        ) {
          this.currentTimeframe = `${parseInt(this.currentTimeframe, 10) - 1}`;
        }
        $ngRedux.dispatch(stateGo('datacenter.main', {
          'currentTimeframe': this.currentTimeframe,
          'startTimeframe': this.startTimeframe,
        }));
      }
    }
  );
}

// Disable selection for new timeframes
Controller.prototype.disabledStart = function(idx) {
  return idx <= parseInt(this.currentTimeframe, 10);
};

// Disable selection for older timeframes
Controller.prototype.disabledEnd = function(idx) {
  if (this.router.currentParams.activeTab !== 'graph') {
    return false;
  }
  return idx >= parseInt(this.startTimeframe, 10);
};



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/directives/refineTimeframe/refineTimeframe.js